import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { downloadZip } from '~/functions/export';
import { ReviewCompanyPdfSection, ReviewCompanyTypstExportStatus, useExportReviewCompanyTypstPdfsLazyQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ExportReviewCompanyTypstPdf',
  props: {
    requestId: null,
    ventures: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var showGhgSection = true;
    var defaultSections = [ReviewCompanyPdfSection.Strategy, ReviewCompanyPdfSection.Carry];
    var showExportDialog = ref(false);
    var selectedExportVentureIds = ref([]);
    var selectedSections = ref([].concat(defaultSections));
    var _useExportReviewCompa = useExportReviewCompanyTypstPdfsLazyQuery({
        input: {
          reviewRequestId: props.requestId,
          ventureIds: [],
          sections: defaultSections
        }
      }, {
        fetchPolicy: 'network-only'
      }),
      load = _useExportReviewCompa.load,
      refetch = _useExportReviewCompa.refetch,
      loading = _useExportReviewCompa.loading;
    var emitUserMessage = function emitUserMessage(type, message, color) {
      window.$nuxt.$emit(type, _objectSpread({
        message: message
      }, color ? {
        color: color
      } : {}));
    };
    var buildExportVariables = function buildExportVariables() {
      return {
        input: {
          reviewRequestId: props.requestId,
          ventureIds: _toConsumableArray(selectedExportVentureIds.value),
          sections: _toConsumableArray(selectedSections.value)
        }
      };
    };
    var finishExport = function finishExport(data) {
      var _result$items, _result$zipFile;
      var result = data === null || data === void 0 ? void 0 : data.exportReviewCompanyTypstPdfs;
      if (!(result !== null && result !== void 0 && (_result$items = result.items) !== null && _result$items !== void 0 && _result$items.length)) {
        emitUserMessage('userError', proxy.$t('exportFailed'));
        return;
      }
      var failures = result.items.filter(function (item) {
        return item.status === ReviewCompanyTypstExportStatus.Error;
      });
      var successCount = result.items.length - failures.length;
      var failedCount = failures.length;
      if ((_result$zipFile = result.zipFile) !== null && _result$zipFile !== void 0 && _result$zipFile.base64String) {
        downloadZip(result.zipFile.base64String, result.zipFile.fileName);
      }
      if (failedCount === result.items.length) {
        emitUserMessage('userError', proxy.$t('exportAllFailed'));
        selectedExportVentureIds.value = failures.map(function (item) {
          return item.ventureId;
        });
        return;
      }
      if (failedCount > 0) {
        emitUserMessage('userError', "".concat(proxy.$t('exportDone'), ": ").concat(proxy.$t('exportDoneDetail', {
          success: successCount,
          failed: failedCount
        })));
        selectedExportVentureIds.value = failures.map(function (item) {
          return item.ventureId;
        });
        return;
      }
      emitUserMessage('userMsg', "".concat(proxy.$t('exportDone'), ": ").concat(proxy.$t('exportDoneDetail', {
        success: successCount,
        failed: failedCount
      })), 'green');
      showExportDialog.value = false;
    };
    var selectAllVentures = function selectAllVentures() {
      selectedExportVentureIds.value = props.ventures.map(function (venture) {
        return venture.ventureId;
      });
    };
    var clearSelectedVentures = function clearSelectedVentures() {
      selectedExportVentureIds.value = [];
    };
    var toggleVentureSelection = function toggleVentureSelection(ventureId) {
      if (selectedExportVentureIds.value.includes(ventureId)) {
        selectedExportVentureIds.value = selectedExportVentureIds.value.filter(function (id) {
          return id !== ventureId;
        });
        return;
      }
      selectedExportVentureIds.value = [].concat(_toConsumableArray(selectedExportVentureIds.value), [ventureId]);
    };
    var openExportDialog = function openExportDialog() {
      selectedExportVentureIds.value = props.ventures.map(function (venture) {
        return venture.ventureId;
      });
      selectedSections.value = [].concat(defaultSections);
      showExportDialog.value = true;
    };
    var closeExportDialog = function closeExportDialog() {
      showExportDialog.value = false;
    };
    var startExport = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var variables, loadResult, refetchResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (selectedExportVentureIds.value.length) {
                _context.next = 3;
                break;
              }
              emitUserMessage('userError', proxy.$t('exportNoSelection'));
              return _context.abrupt("return");
            case 3:
              if (selectedSections.value.length) {
                _context.next = 6;
                break;
              }
              emitUserMessage('userError', proxy.$t('exportNoSections'));
              return _context.abrupt("return");
            case 6:
              variables = buildExportVariables();
              _context.prev = 7;
              loadResult = load(null, variables);
              if (!(loadResult instanceof Promise)) {
                _context.next = 16;
                break;
              }
              _context.t0 = finishExport;
              _context.next = 13;
              return loadResult;
            case 13:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              return _context.abrupt("return");
            case 16:
              _context.next = 18;
              return refetch(variables);
            case 18:
              refetchResult = _context.sent;
              finishExport(refetchResult === null || refetchResult === void 0 ? void 0 : refetchResult.data);
              _context.next = 25;
              break;
            case 22:
              _context.prev = 22;
              _context.t2 = _context["catch"](7);
              emitUserMessage('userError', proxy.$t('exportFailed'));
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[7, 22]]);
      }));
      return function startExport() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      showGhgSection: showGhgSection,
      defaultSections: defaultSections,
      showExportDialog: showExportDialog,
      selectedExportVentureIds: selectedExportVentureIds,
      selectedSections: selectedSections,
      load: load,
      refetch: refetch,
      loading: loading,
      emitUserMessage: emitUserMessage,
      buildExportVariables: buildExportVariables,
      finishExport: finishExport,
      selectAllVentures: selectAllVentures,
      clearSelectedVentures: clearSelectedVentures,
      toggleVentureSelection: toggleVentureSelection,
      openExportDialog: openExportDialog,
      closeExportDialog: closeExportDialog,
      startExport: startExport,
      ReviewCompanyPdfSection: ReviewCompanyPdfSection
    };
  }
});